import { render } from "./GroupChat.vue?vue&type=template&id=9ad60040&scoped=true&ts=true"
import script from "./GroupChat.vue?vue&type=script&lang=ts"
export * from "./GroupChat.vue?vue&type=script&lang=ts"

import "./GroupChat.vue?vue&type=style&index=0&id=9ad60040&scoped=true&lang=css"
import "./GroupChat.vue?vue&type=style&index=1&id=9ad60040&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ad60040"]])

export default __exports__
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QField from 'quasar/src/components/field/QField.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpace,QBadge,QBtn,QSelect,QIcon,QMenu,QList,QItem,QItemSection,QCheckbox,QTooltip,QInput,QSpinner,QDialog,QCard,QForm,QCardSection,QCardActions,QLinearProgress,QToolbar,QToolbarTitle,QSeparator,QField});qInstall(script, 'directives', {ClosePopup});
